import React, { useState } from 'react';
import Step from './Step';
import css from './ProgressBar.css';

export default function StepNavigation(props) {
// const StepNavigation = props => {
    
var curStatus=<div></div>;

switch (props.status) {
case 1: curStatus = (<div className={css.enquired}>
    {props.labelArray.map((item, index) => <Step key={index} index={index} label={item}></Step>)}
    </div>);
break
case 2: curStatus = (<div className={css.requested}>
    {props.labelArray.map((item, index) => <Step key={index} index={index} label={item}></Step>)}
    </div>);
break
case 3: curStatus = (<div className={css.accepted}>
    {props.labelArray.map((item, index) => <Step key={index} index={index} label={item}></Step>)}
    </div>);
break
case 4: curStatus = (<div className={css.delivered}>
    {props.labelArray.map((item, index) => <Step key={index} index={index} label={item}></Step>)}
    </div>);
break
case 5: curStatus = (<div className={css.requestedProvider}>
    {props.labelArray.map((item, index) => <Step key={index} index={index} label={item}></Step>)}
    </div>);
break
case 6: curStatus = (<div className={css.acceptedProvider}>
    {props.labelArray.map((item, index) => <Step key={index} index={index} label={item}></Step>)}
    </div>);
break
case 7: curStatus = (<div className={css.deliveredProvider}>
    {props.labelArray.map((item, index) => <Step key={index} index={index} label={item}></Step>)}
    </div>);
break
}

return (
    <>
            {curStatus}
    </>
    )
}
// export default StepNavigation;